import { render, staticRenderFns } from "./side-base.vue?vue&type=template&id=33d18448&scoped=true&"
import script from "./side-base.vue?vue&type=script&lang=js&"
export * from "./side-base.vue?vue&type=script&lang=js&"
import style0 from "./side-base.vue?vue&type=style&index=0&id=33d18448&lang=scss&scoped=true&"
import style1 from "./side-base.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d18448",
  null
  
)

export default component.exports